<!-- Inline progress for a single control (a probing row, a submitting button). -->
<script lang="ts">
  interface Props {
    size?: number;
    label?: string;
  }
  let { size = 16, label = 'Working' }: Props = $props();
</script>

<svg
  class="spinner"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  role="status"
  aria-label={label}
  style:--ring="{Math.max(1.6, size / 9)}px"
>
  <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.2" opacity="0.22" />
  <path
    d="M21 12a9 9 0 0 0-9-9"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
  />
</svg>

<style>
  .spinner {
    display: block;
    flex: none;
    animation: spin 780ms linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .spinner {
      animation-duration: 2s;
    }
  }
</style>
